module.exports = __webpack_public_path__ + "static/media/bluejays-ringer-dt-en.b31bd419.jpg";